import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const createPendingTextToSubscribeRecord = unaryRpc({
  name: "createPendingTextToSubscribeRecord",
  input: z.object({
    formId: z.string(),
    treatmentId: z.string().nullish(),
    anonymousId: z.string(),
  }),
  output: z.object({ lookupId: z.string() }),
});
